import LanguageRouter from './Components/LanguageRouter';
import * as React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'

function App() {
  return (
      <HelmetProvider>
        <div className="App">
          <BrowserRouter>
            <LanguageRouter />
          </BrowserRouter>
        </div>
      </HelmetProvider>
    );
}

export default App;
